import { Seo } from '@domains/seo';

export type Address = {
    text: string | null;
    latitude: number | null;
    longitude: number | null;
};

export type Contacts = {
    working_hours: string | null;
    address: Address;
    order: {
        phones: string[];
        emails: string[];
    };
    delivery: {
        phones: string[];
    };
    b2b: {
        phones: string[];
        emails: string[];
    };
    seo: Seo;
};

export enum SocialContactType {
    Max = 'max',
    Telegram = 'telegram',
    Phone = 'phone',
}

export type SocialContact = {
    type: SocialContactType;
    href: string;
    ariaLabel: string;
};
